import { createCrudService } from '@/services/api/createCrudService'

export interface Bank {
  id: string
  code: string
  name: string
  fullName: string | null
  status: 'ATIVO' | 'INATIVO'
}

export const BanksService = createCrudService<Bank>('/settings/banks', { searchField: 'name' })
